import React, { useEffect, useState } from 'react';

import { getSchoolReviewDemoAccess, removeSchoolReviewDemo, resetSchoolReviewDemo } from '../../../api/organizationApi';
import { useToast } from '../../../components/Toast';

const DEMO_TEXT = '가상 학생 150명의 행특·세특·창체로 검토 화면을 바로 보여줄 수 있어요. 실제 학생 정보는 쓰지 않아요.';

export const DemoSchoolCreateCard = ({ currentUser }) => {
  const { showToast } = useToast();
  const [allowed, setAllowed] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    getSchoolReviewDemoAccess(currentUser)
      .then((result) => { if (alive) setAllowed(Boolean(result?.allowed)); })
      .catch(() => {});
    return () => { alive = false; };
  }, [currentUser]);

  if (!allowed) return null;

  const handleCreate = async () => {
    setBusy(true);
    try {
      const { review_id: reviewId } = await resetSchoolReviewDemo(currentUser);
      showToast('시연 학교를 만들었어요.', 'success', 4000);
      window.location.assign(`/school-admin/review/${reviewId}`);
    } catch (error) {
      showToast(error.message, 'error', 5000);
      setBusy(false);
    }
  };

  return (
    <section className="school-card school-demo-card" data-testid="school-demo-create">
      <p className="school-eyebrow">왓퀴즈 팀 전용</p>
      <h2>선생님께 보여줄 시연 학교 만들기</h2>
      <p>{DEMO_TEXT}</p>
      <button type="button" className="school-btn-primary" onClick={handleCreate} disabled={busy}>
        {busy ? '만드는 중이에요 (1분쯤 걸려요)' : '시연용 학교 만들기'}
      </button>
    </section>
  );
};

export const DemoSchoolBanner = ({ currentUser }) => {
  const { showToast } = useToast();
  const [busy, setBusy] = useState('');

  const run = async (kind) => {
    setBusy(kind);
    try {
      if (kind === 'reset') {
        await resetSchoolReviewDemo(currentUser);
        showToast('시연 학교를 처음 상태로 되돌렸어요.', 'success', 4000);
      } else {
        await removeSchoolReviewDemo(currentUser);
        showToast('시연 학교를 지웠어요.', 'success', 4000);
      }
      window.location.reload();
    } catch (error) {
      showToast(error.message, 'error', 5000);
      setBusy('');
    }
  };

  return (
    <div className="school-demo-banner" role="note" data-testid="school-demo-banner">
      <span><strong>시연 학교예요.</strong> 학생과 기록은 모두 가상 데이터예요.</span>
      <div>
        <button type="button" className="school-btn-secondary" onClick={() => run('reset')} disabled={Boolean(busy)}>
          {busy === 'reset' ? '되돌리는 중' : '처음 상태로 되돌리기'}
        </button>
        <button type="button" className="school-demo-remove" onClick={() => run('remove')} disabled={Boolean(busy)}>
          {busy === 'remove' ? '지우는 중' : '시연 학교 지우기'}
        </button>
      </div>
    </div>
  );
};
